export default {"src":"/_next/static/media/xvg.b5fa5962.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};